<template lang="pug">
#app
  v-container(grid-list-xl, fluid)
    v-layout(v-if="$root.user.permissao != 0", row, wrap)
      AccessLock
    v-layout(v-if="$root.user.permissao == 0", row, wrap)
      v-flex(lg12)
        v-card
          v-toolbar(card, color='white')
            v-text-field.hidden-sm-and-down(flat, solo, prepend-icon='search', placeholder='Buscar tipo de questionário', v-model='search', hide-details)
            v-switch.mt-4(:false-value="0", :true-value="1", :color="filter.ativo ? 'success': ''", :label="filter.ativo ? 'Tipos de questionários ativos' : 'Tipos de questionários inativos'", v-model="filter.ativo")
            v-btn(color="bt-primary", @click.native="openDialogTipoQuestionario(null)").white--text Cadastrar
          v-divider
          v-card-text.pa-2
            v-data-table(:headers='headers', :search='search', :items='list', :rows-per-page-items="[25,50,75,{text:'Todos','value':-1}]", :loading="loading").elevation-0
              template(slot='items', slot-scope='props')
                td(width="5%").text-xs-center {{ props.item.id }}
                td.text-xs-left {{ props.item.nome }}
                td(width="15%").text-xs-center
                  v-tooltip(top)
                    v-btn(slot="activator", flat, icon, fab, dark, color='bt-primary', small, @click.native="openDialogTipoQuestionario(props.item)")
                      v-icon edit
                    span Editar
                  v-tooltip(top)
                    v-btn(slot="activator", flat, icon, fab, dark, :color="props.item.ativo ? 'red' : 'warning'", small, @click="changeAtivo(props.item)")
                      v-icon {{ props.item.ativo ? 'delete' : 'restore' }}
                    span {{ props.item.ativo ? 'Desativar' : 'Ativar' }}

    v-dialog(v-model="dialogTipoQuestionario", width="auto", scrollable, max-width="500px", persistent, v-if="dialogTipoQuestionario")
      v-card
        form(@submit.prevent="salvar('tipo_questionario')", data-vv-name="tipo_questionario")
          v-card-title.headline.grey.lighten-2
            v-layout(row, wrap)
              v-flex.md11
                span.headline {{ tipo_questionarioEdit && tipo_questionarioEdit.id ? 'Editar tipo de questionário' : 'Cadastrar tipo de questionário' }}
              v-flex.md1.text-xs-right
                v-tooltip(top)
                  v-btn(icon, slot="activator", @click.native="$validator.pause(); dialogTipoQuestionario = null; tipo_questionarioEdit = {}").pa-0.mx-0.my-0.ma-0
                    v-icon close
                  span Fechar
          v-divider
          v-card-text
              v-layout(row, wrap)
                v-flex.xs12.md12
                  v-text-field(color="primary", label='Nome', required, v-validate="'required'", :error-messages="errors.collect('nome')", data-vv-name="nome", type="text", v-model='tipo_questionarioEdit.nome', autofocus)
          v-divider
          v-card-actions.headline.grey.lighten-2
            v-layout(row, wrap).pa-1
              v-flex.xs12.text-xs-right
                v-btn(color="black", flat, @click.native="dialogTipoQuestionario = false; tipo_questionarioEdit = {}") Fechar
                v-btn(type="submit", color="bt-primary", :loading='loading').white--text Salvar
                
</template>

<script>
import _ from 'lodash';
import AccessLock from '@/components/AccessLock';

export default {
  components: {
    AccessLock
  },
  data: () => ({
    filter: { ativo: 1 },
    tipos_questionarios: [],
    tipo_questionario: {},
    tipo_questionarioEdit: {},
    dialogTipoQuestionario: false,
    headers: [
      { text: '#', align: 'left', value: 'id' },
      { text: 'Nome', align: 'left', value: 'nome' },
      { text: 'Ações', align: 'center', sortable: false },
    ],
    search: '',
    loading: false
  }),
  computed: {
    list () {
      return _.filter(this.tipos_questionarios, { ativo: this.filter.ativo });
    }
  },
  mounted () {
    this.getTiposQuestionarios();
  },
  methods: {
    async getTiposQuestionarios () {
      const vm = this;
      try {
        vm.loading = true;
        const response = await vm.$axios.get('/tipo-questionario', { params: { padrao : 0 } });
        vm.tipos_questionarios = response.data.rows;
        vm.loading = false;
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao buscar os dados. Atualize a página!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },
    async changeAtivo (tipo_questionario) {
      const vm = this;
      try {
        const obj = _.cloneDeep(tipo_questionario);
        obj.ativo = obj.ativo ? 0 : 1;
        const response = await vm.$axios.put(`/tipo-questionario/${obj.id}`, obj);
        tipo_questionario.ativo = response.data.ativo;
        window.getApp.$emit('APP_ALERT', { color: obj.ativo ? 'success' : 'orange', text: `Tipo de questionário ${tipo_questionario.ativo ? 'ativado' : 'desativado'} com sucesso!` });
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao salvar o tipo de questionário. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
      }
    },
    async remove (tipo_questionario) {
      const vm = this;
      try {
        const res = await vm.$confirm('Deseja realmente excluir?<br> Essa ação não poderá ser desfeita!');
        if (!res) return;
        const response = await vm.$axios.delete(`/tipo-questionario/${tipo_questionario.id}`);
        vm.tipos_questionarios = _.reject(vm.tipos_questionarios, { id: tipo_questionario.id });
        window.getApp.$emit('APP_ALERT', { color: 'success', text: 'Tipo de questionário excluído com sucesso!' });
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao excluir o tipo de questionário. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
      }
    },
    async save (tipo_questionario) {
      const vm = this;
      try {
        vm.loading = true;
        const response = await vm.$axios.post('/tipo-questionario', tipo_questionario);
        if (response && response.data && response.data.id) {
          vm.tipos_questionarios.push(response.data);
          vm.tipo_questionario = false;
        }
        vm.dialogTipoQuestionario = false;
        vm.tipo_questionarioEdit = {};
        vm.loading = false;
        window.getApp.$emit('APP_ALERT', { color: 'success', text: 'Tipo de questionário salva com sucesso!' });
      } catch (error) {
        vm.loading = false;
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao salvar o tipo de questionário. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
      }
    },
    async update (tipo_questionario) {
      const vm = this;
      try {
        const response = await vm.$axios.put(`/tipo-questionario/${tipo_questionario.id}`, tipo_questionario);
        const index = _.findIndex(vm.tipos_questionarios, { id: tipo_questionario.id });
        const tipos_questionarios = _.reject(vm.tipos_questionarios, { id: tipo_questionario.id });
        vm.tipos_questionarios = [...tipos_questionarios.slice(0, index), response.data, ...tipos_questionarios.slice(index)];
        window.getApp.$emit('APP_ALERT', { color: 'success', text: 'Tipo de questionário salvo com sucesso!' });
        vm.dialogTipoQuestionario = false;
        vm.tipo_questionarioEdit = {};
        vm.loading = false;
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao atualizar o tipo de questionário. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },
    async salvar (scope) {
      const vm = this;
      try {
        vm.loading = true;  
        const result = await vm.$validator.validateAll();
        if (!result) throw 'Preencha todos os campos corretamente!';
        if (scope === 'tipo_questionario') {
          vm[vm.tipo_questionarioEdit.id ? 'update' : 'save'](vm.tipo_questionarioEdit);
        }
        vm.$validator.reset();
      } catch (error) {
        window.getApp.$emit('APP_ALERT', { color: 'red', text: error });
        vm.loading = false;
      }
    },
    async openDialogTipoQuestionario (tipo_questionario) {
      const vm = this;
      if (tipo_questionario) {
          vm.tipo_questionarioEdit = _.cloneDeep(tipo_questionario);
          if (vm.tipo_questionarioEdit && vm.tipo_questionarioEdit.id) {
          const response = await vm.$axios.get(`/tipo-questionario/${vm.tipo_questionarioEdit.id}`,  { params: { padrao : 0 } });
          vm.tipo_questionarioEdit = response.data;
          }
      }
      vm.dialogTipoQuestionario = true;
    }
  }
};
</script>

<style scoped>

</style>

